var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, Box } from '..';
import BackdropLoader from '../../assets/img/backdrop-loader.png';
import useStyles from './styles';
export default (_a) => {
    var { isFullScreen = false, size = 20 } = _a, otherProps = __rest(_a, ["isFullScreen", "size"]);
    const { classes } = useStyles();
    if (isFullScreen) {
        _jsx(Backdrop, Object.assign({ className: classes.backdrop, open: true }, { children: _jsx("img", { src: BackdropLoader }) }));
    }
    return (_jsx(Box, Object.assign({}, otherProps, { children: _jsx("img", { src: BackdropLoader, style: { height: size, width: size } }) })));
};
//# sourceMappingURL=index.js.map